var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDefault = function SvgIconDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#24221C",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.533.507c1.844.033 3.847.21 5.627 1.024l.406.2.035.02c4.498 2.374 4.97 7.278 3.935 10.883-.607 2.122-1.682 4.124-2.774 5.98a46 46 0 0 1-3.853 5.535v.001c-.632.786-1.677.598-2.186.058v-.001c-1.951-2.076-3.985-4.23-5.6-6.613v-.001c-1.956-2.879-3.31-6.248-3.102-9.74.09-1.517.502-3.16 1.6-4.554h.002l.221-.267C6.986 1.733 8.607.918 10.376.535c.12-.027.228-.035.32-.035zM10.751 2.5c-1.536.341-2.777 1.046-3.559 2.036l.001.001c-.767.973-1.1 2.178-1.176 3.435-.162 2.72.816 5.468 2.43 7.996l.331.503.288.416c1.35 1.909 2.99 3.686 4.69 5.498a44 44 0 0 0 2.872-4.105l.41-.682c1.078-1.829 2.041-3.65 2.575-5.516h.001l.08-.298c.764-2.987.21-6.368-2.748-8.11l-.304-.168-.02-.013c-1.649-.858-3.692-.99-5.871-.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.849 4.345c.433-.045.85-.01 1.207.036l.394.058.016.003c.29.048.514.189.676.345q.015.01.029.023c.536.503 1.146 1.148 1.582 1.909.443.772.735 1.718.537 2.774v.001c-.32 1.697-1.846 2.778-3.343 2.928a4.6 4.6 0 0 1-2.487-.49C9.73 11.556 9 10.887 8.8 9.88l-.031-.206c-.085-.71-.097-1.503.046-2.264.157-.835.584-1.532 1.095-2.08l.165-.165a3.02 3.02 0 0 1 1.51-.783h.002zm1.07 2.038c-.409-.058-.702-.083-.973-.034h.001c-.182.034-.386.146-.577.348-.317.342-.519.706-.589 1.082v.001c-.095.507-.094 1.087-.026 1.658l.016.089c.058.211.235.437.61.631a2.6 2.6 0 0 0 1.365.274h.002l.147-.02c.722-.13 1.311-.665 1.43-1.289.085-.455-.023-.915-.306-1.41-.267-.464-.663-.908-1.1-1.33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 18.996,
    height: 25.177,
    x: 3.5,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1 1",
    numOctaves: 3,
    seed: 1341,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    width: "100%",
    height: "100%",
    "in": "shape",
    result: "displacedImage",
    scale: 1,
    xChannelSelector: "R",
    yChannelSelector: "G"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_10259_8441"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "displacedImage"
  })), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "2 2",
    numOctaves: 3,
    result: "noise",
    seed: 1299,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "effect1_texture_10259_8441",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#FFF",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_10259_8441"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "effect1_texture_10259_8441"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))))));
};
export default SvgIconDefault;